import React from 'react';
import { AccordionContent, AccordionTitle } from 'semantic-ui-react';

export { Accordion, AccordionContent, AccordionTitle } from 'semantic-ui-react';

export type AccordionItemProps = {
  active: boolean;
  index?: number | string;
  onClick: () => void;
  title: React.ReactNode;
  content: React.ReactNode;
  titleStyle?: React.CSSProperties;
  contentClassName?: string;
};

export function AccordionItem({
  title,
  content,
  active,
  onClick,
  index,
  titleStyle,
  contentClassName,
}: AccordionItemProps) {
  return (
    <>
      <AccordionTitle active={active} onClick={onClick} index={index} style={titleStyle}>
        {title}
      </AccordionTitle>
      <AccordionContent active={active} className={contentClassName}>
        {active ? content : null}
      </AccordionContent>
    </>
  );
}
